import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import {QRCodeSVG} from 'qrcode.react';

import {formatDate, trans} from "../../../common/utils";


export const CouponQrCode = (
    {
        code,
        language
    }
) => {
    useEffect(() => {
        ReactDOM.render(
            <QRCodeSVG
                value={code.toString()}
                bgColor="#fff"
                size={150}
                marginSize={2}
            />,
            document.getElementById('coupon-QR-code')
        );
    }, []);

    return (
        <div className="coupon-code">
            <div id="coupon-QR-code" className="coupon-code__qr"/>
            <p className="coupon-code__number-text">{trans('Reservation Number')}: <span className="coupon-code__number">{code}</span></p>
            <p className="coupon-code__text" dangerouslySetInnerHTML={{__html: trans('QR code is only valid for 4 hours').replace('{{TIMER}}', '<span class="coupon-code__text-timer">' + formatDate(new Date(new Date().getTime() + (4 * 60 * 60 * 1000)), "DD.MM.YYYY, HH:mm:SS", language) + '</span>')}}/>
        </div>
    );
}